import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../App';
import MeliOrder from './MeliOrder';

const GlobalShopOrders = () => {
    const navigate = useNavigate();
    const { logout } = useSession();

    const handleLogout = () => {
        // Clear auth tokens
        localStorage.removeItem('authToken');
        localStorage.removeItem('userType');
        localStorage.removeItem('username');

        // Logout and redirect to login
        logout();
        navigate('/index');
    };

    return (
        <>
            {/* Header */}
            <div className="bg-dark text-white py-3">
                <Container>
                    <Row className="align-items-center">
                        <Col>
                            <h4 className="mb-0">📦 Orders Management</h4>
                        </Col>
                        <Col xs="auto">
                            <Button variant="outline-light" onClick={handleLogout}>
                                🚪 Logout
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container className="py-5" style={{ maxWidth: '500px' }}>
                <MeliOrder />
            </Container>
        </>
    );
};

export default GlobalShopOrders;
